import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/webinars/$slug")({
  head: () => buildRouteHead("/webinars/$slug", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/webinars", replace: true });
  },
});
